// extracted by mini-css-extract-plugin
export default {"booked":"styles_booked__OVV1b","waiting":"styles_waiting__jHJKv","cursorPointer":"styles_cursorPointer__8L2he"};